<template>
    <div class="settings-page__privacy-policy">
        <privacy-policy @ready="onReadePrivacyPolicy" @start="onStartPrivacyPolicy" />
    </div>
</template>

<script setup lang="ts">
    const emit = defineEmits(['data-loading']);

    const onStartPrivacyPolicy = (): void => {
        emit("data-loading", true);
    };
    const onReadePrivacyPolicy = (): void  => {
        emit("data-loading", false);
    };
</script>
